if (!customElements.get("ls-collection-price-fill")) {
  customElements.define(
    "ls-collection-price-fill",
    class LsCollectionPriceFill extends HTMLElement {
      connectedCallback() {
        const range = this.closest(".price-range");
        this.track = range && range.querySelector(".price-range__track");
        this.inputs = range && range.querySelectorAll(".price-range__input");
        if (!this.track || !this.inputs || this.inputs.length < 2) return;

        this.paint = this.paint.bind(this);
        this.inputs.forEach((input) => input.addEventListener("input", this.paint));
        this.paint();
      }

      disconnectedCallback() {
        if (!this.inputs) return;
        this.inputs.forEach((input) => input.removeEventListener("input", this.paint));
      }

      paint() {
        const [from, to] = this.inputs;
        const min = parseFloat(from.min) || 0;
        const max = parseFloat(from.max) || 100;
        const span = max - min || 1;
        let lo = parseFloat(from.value);
        let hi = parseFloat(to.value);
        if (lo > hi) [lo, hi] = [hi, lo];

        const pct = (value) => (((value - min) / span) * 100).toFixed(2) + "%";
        this.track.style.setProperty("--ls-collection-fill-from", pct(lo));
        this.track.style.setProperty("--ls-collection-fill-to", pct(hi));
      }
    }
  );
}
